/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ first: NonNullable<unknown>, second: NonNullable<unknown> }} Endpoint_Play_SettledInputs */

const en_endpoint_play_settled = /** @type {(inputs: Endpoint_Play_SettledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`If ${i?.first} fails, ${i?.second} takes over in the same call.`)
};

const zh_hans1_endpoint_play_settled = /** @type {(inputs: Endpoint_Play_SettledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`如果 ${i?.first} 失败，${i?.second} 会在同一次调用中接手。`)
};

const pt_br2_endpoint_play_settled = /** @type {(inputs: Endpoint_Play_SettledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se ${i?.first} falhar, ${i?.second} assume na mesma chamada.`)
};

const es_endpoint_play_settled = /** @type {(inputs: Endpoint_Play_SettledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Si ${i?.first} falla, ${i?.second} toma el relevo en la misma llamada.`)
};

const fr_endpoint_play_settled = /** @type {(inputs: Endpoint_Play_SettledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Si ${i?.first} échoue, ${i?.second} prend le relais dans le même appel.`)
};

const de_endpoint_play_settled = /** @type {(inputs: Endpoint_Play_SettledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fällt ${i?.first} aus, übernimmt ${i?.second} im selben Aufruf.`)
};

const ru_endpoint_play_settled = /** @type {(inputs: Endpoint_Play_SettledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Если ${i?.first} не ответит, ${i?.second} заменит его в том же вызове.`)
};

const it_endpoint_play_settled = /** @type {(inputs: Endpoint_Play_SettledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se ${i?.first} fallisce, subentra ${i?.second} nella stessa chiamata.`)
};

/**
* | output |
* | --- |
* | "If {first} fails, {second} takes over in the same call." |
*
* @param {Endpoint_Play_SettledInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_play_settled = /** @type {((inputs: Endpoint_Play_SettledInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Play_SettledInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_play_settled(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_play_settled(inputs)
	if (locale === "es") return es_endpoint_play_settled(inputs)
	if (locale === "fr") return fr_endpoint_play_settled(inputs)
	if (locale === "de") return de_endpoint_play_settled(inputs)
	if (locale === "ru") return ru_endpoint_play_settled(inputs)
	if (locale === "it") return it_endpoint_play_settled(inputs)
	return en_endpoint_play_settled(inputs)
});